// extracted by mini-css-extract-plugin
export default {"container":"Presentacion_container__8ueYs","title":"Presentacion_title__-9IB-","text":"Presentacion_text__y-X7M"};